export const DO_NOT_DISTURB_TARGETING_SECTION_KEY = 'doNotDisturbTargetingSectionKey';
